// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BuildFilledSvg from "@fishx/icons-svg/es/asn/BuildFilled";
import FishxIcon from '../components/FishxIcon';

var BuildFilled = function BuildFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BuildFilledSvg
  }));
};

BuildFilled.displayName = 'BuildFilled';
export default React.forwardRef(BuildFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BuildFilled.js
// module id = 2128
// module chunks = 0